import {
  Campaign,
  Status_Enum as Status,
  UpdateCampaignRequest,
} from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';

/**
 * Creates an update request to change a campaign's status
 * @param orgId The organization ID that owns the campaign
 * @param campaign The campaign object to update
 * @param status The new status to set for the campaign
 * @returns An UpdateCampaignRequest object with the campaign status updated and proper update mask
 */
export const createCampaignStatusUpdateRequest = (
  orgId: string,
  status: Status,
  campaign: Campaign
): UpdateCampaignRequest => {
  const campaignPaths = ['campaign.currentStatus'];
  return {
    orgId,
    campaign: {
      ...campaign,
      currentStatus: status,
    },
    updateMask: {
      paths: campaignPaths,
      toJSON: () => campaignPaths.join(','),
    },
  };
};
